import {observable, computed} from 'mobx';
import {t} from 'shared/core';

class FormElementViewModel {
  @observable id;
  @observable name;
  @observable inputType;
  @observable annotationType = 'input';
  @observable isRequired;

  constructor({name, inputType, isRequired = true, isTotalClaimAmount = false, isIncomeLessThanClaimAmount = false, isAdditionalTax = false}) {
    this.name = name;
    this.inputType = inputType;
    this.isRequired = isRequired;
    this.isTotalClaimAmount = isTotalClaimAmount;
    this.isIncomeLessThanClaimAmount = isIncomeLessThanClaimAmount;
    this.isAdditionalTax = isAdditionalTax;
  }

  static textField() {
    return new FormElementViewModel({
      name: t('components.pdf.annotate.toolbar.Single-line Text'),
      inputType: 'text'
    });
  }

  static totalClaimAmountField() {
    return new FormElementViewModel({
      name: 'Total Claim Amount',
      inputType: 'text',
      isTotalClaimAmount: true
    });
  }

  static incomeLessThanClaimAmountField() {
    return new FormElementViewModel({
      name: 'Total Income Less Than Total Claim Amount',
      inputType: 'checkbox',
      isIncomeLessThanClaimAmount: true,
      isRequired: false
    });
  }

  static additionalTaxField() {
    return new FormElementViewModel({
      name: 'Additional Tax',
      inputType: 'text',
      isAdditionalTax: true,
      isRequired: false
    });
  }

  static optionalTextField() {
    return new FormElementViewModel({
      name: t('components.pdf.annotate.toolbar.Optional Single-line Text'),
      inputType: 'text',
      isRequired: false
    });
  }

  static textAreaField() {
    return new FormElementViewModel({
      name: t('components.pdf.annotate.toolbar.Multi-line Text'),
      inputType: 'textarea'
    });
  }

  static optionalTextAreaField() {
    return new FormElementViewModel({
      name: t('components.pdf.annotate.toolbar.Optional Multi-line Text'),
      inputType: 'textarea',
      isRequired: false
    });
  }

  static checkboxField() {
    return new FormElementViewModel({
      name: t('components.pdf.annotate.toolbar.Checkbox Field'),
      inputType: 'checkbox',
      isRequired: false
    });
  }

  static fromHash(hash) {
    return new FormElementViewModel(hash);
  }

  @computed get label() {
    if (this.isTotalClaimAmount) return 'Claim Amount';
    if (this.isAdditionalTax) return 'Additional Tax';

    switch (this.inputType) {
      case 'text':
        return this.isRequired ?
          t('components.pdf.annotate.input_label.Text') :
          t('components.pdf.annotate.input_label.Optional Text');
      case 'textarea':
        return this.isRequired ?
          t('components.pdf.annotate.input_label.Multi-line Text') :
          t('components.pdf.annotate.input_label.Optional Multi-line Text');
      default:
        return '';
    }
  }
}

export default FormElementViewModel;
